import {defineStore} from 'pinia'
import {ref, onMounted} from 'vue'

export const useGetLangCurrent = defineStore('useAllCourse', () => {
  const lang_switch = ref<Array<any>>([])
  return {
    lang_switch
  }
})
